import React from 'react';
import GridFiltersBar from '../GridUsuario/GridFiltersBar';

const STATUS_FILTER_OPTIONS = [
  { value: '1', label: 'Somente ativos' },
  { value: '0', label: 'Somente inativos' },
  { value: '', label: 'Todos os status' },
];

interface ProductLookupFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  filterActive: string;
  onFilterActiveChange: (value: string) => void;
  totalShowing: number;
  showAdvanced: boolean;
  onToggleAdvanced: () => void;
  hasActiveFilters: boolean;
  onClear: () => void;
  searchPlaceholder: string;
  viewToggle?: React.ReactNode;
}

const ProductLookupFilters = (props: ProductLookupFiltersProps) => (
  <GridFiltersBar
    searchQuery={props.searchQuery}
    onSearchChange={props.onSearchChange}
    onSearch={props.onSearch}
    searchPlaceholder={props.searchPlaceholder}
    searchAriaLabel={props.searchPlaceholder}
    filterValue={props.filterActive}
    onFilterChange={props.onFilterActiveChange}
    filterAriaLabel="Filtrar por status"
    filterEmptyLabel="Todos os status"
    filterOptions={STATUS_FILTER_OPTIONS}
    includeEmptyOption={false}
    totalShowing={props.totalShowing}
    showAdvanced={props.showAdvanced}
    onToggleAdvanced={props.onToggleAdvanced}
    hasActiveFilters={props.hasActiveFilters}
    onClear={props.onClear}
    viewToggle={props.viewToggle}
  />
);

export default ProductLookupFilters;
